import { ImageInspectionRow } from "./ImageInspectionRow";
import { useState } from "react";
import { getIn, useFormikContext } from "formik";
import ComboBox from "../../../../../../../../common/components/form/ComboBox";
import { RecoveryReason } from "../../../../../../../../types/renter.type";

type RegisterPhotosProps = {
  title: string;
  items: Array<{ type: string; content: string; verified?: boolean }>;
  vehicleId: string;
  renterId: string;
  nameRenter: string;
  onAddItem: () => void;
  onRemoveItem?: (index: number) => void;
  onClose?: () => void;
  updateStatus?: (status: string, complement: string) => Promise<void>;
  titleTextArea: string;
};

const RegisterPhotos: React.FC<RegisterPhotosProps> = ({
  title,
  items,
  onAddItem,
  titleTextArea,
  vehicleId,
}) => {
  const { setFieldValue } = useFormikContext();
  const [complement, setComplement] = useState("");
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formik = useFormikContext<any>();

  const registers = getIn(formik.values, 'registers')
  const returnReason = getIn(formik.values, 'returnReason');
  const optionRepossesion = getIn(formik.values, 'optionRepossesion');

  const handleComplementChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    setComplement(newValue);
    setFieldValue("returnReason", newValue);
  };

  const optionsRepossession = Object.entries(RecoveryReason)
    .filter(([key]) => key !== "UNDEFINED")
    .map(([key, value]) => ({
      label: value,
      value: key,
    }));

  return (
    <section>
      <div className="grid gap-2">
        <h2 className="text-2xl font-semibold mb-4">{title}</h2>
        {items.map((item, index) => (
          <div
            key={index}
            className={`space-x-3 px-3 py-2 my-0 rounded ${index % 2 ? "bg-gray/5" : "bg-gray/25"
              }`}
          >
            <ImageInspectionRow
              initialData={item || {}}
              name={`registers.${index}`}
              onRemoveClick={() =>
                formik.setFieldValue(
                  "registers",
                  registers.filter((_, i) => i !== index)
                )
              }
              prefix="devolucao"
              vehicleId={vehicleId}
            />
          </div>
        ))}

        <button type="button" onClick={onAddItem}>
          + Adicionar registro
        </button>
      </div>

      <div>
        <ComboBox
          name='optionRepossesion'
          label='Escolha o motivo da devolução:'
          options={optionsRepossession}
          value={optionRepossesion}
        />
      </div>

      <div className="flex flex-col gap-1">
        <label
          className="block font-medium text-gray-600"
          htmlFor="otherReason"
        >
          {titleTextArea}
        </label>
        <textarea
          id="otherReason"
          name="returnReason"
          placeholder="Descreva as avaliações realizada na moto..."
          value={complement || returnReason}
          onChange={handleComplementChange}
          style={{ resize: "none", height: "90px" }}
        />

        {!formik.touched.returnReason && formik.errors.returnReason && (
          <div className="text-redPrimary text-sm">
            {formik.errors.returnReason.toString()}
          </div>
        )}
      </div>
    </section>
  );
};

export default RegisterPhotos;
